// Simple progressive enhancement
document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-qty]');
  if (!btn) return;
  const wrap = btn.closest('.qty');
  const input = wrap.querySelector('input[name="quantity"]');
  const span = wrap.querySelector('span');
  let v = parseInt(input.value || '1', 10);
  v = btn.dataset.qty === '+' ? v + 1 : Math.max(1, v - 1);
  input.value = v;
  if (span) span.textContent = String(v).padStart(2, '0');
});

// Product image carousel
document.querySelectorAll('[data-product-carousel]').forEach((carousel) => {
  const track = carousel.querySelector('[data-carousel-track]');
  const slides = Array.from(carousel.querySelectorAll('[data-carousel-slide]'));
  const prevBtn = carousel.querySelector('[data-carousel-prev]');
  const nextBtn = carousel.querySelector('[data-carousel-next]');
  const thumbs = Array.from(carousel.querySelectorAll('[data-carousel-thumb]'));
  const counter = carousel.querySelector('[data-carousel-current]');
  if (!track || slides.length === 0) return;

  let index = 0;

  function goTo(i) {
    index = (i + slides.length) % slides.length;
    track.style.transform = `translateX(-${index * 100}%)`;
    thumbs.forEach((t, ti) => t.classList.toggle('is-active', ti === index));
    if (counter) counter.textContent = String(index + 1);
  }

  prevBtn && prevBtn.addEventListener('click', () => goTo(index - 1));
  nextBtn && nextBtn.addEventListener('click', () => goTo(index + 1));
  thumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => goTo(parseInt(thumb.dataset.index, 10)));
  });

  // Swipe support
  let startX = 0;
  let isDragging = false;
  track.addEventListener('pointerdown', (e) => {
    isDragging = true;
    startX = e.clientX;
  });
  track.addEventListener('pointerup', (e) => {
    if (!isDragging) return;
    isDragging = false;
    const diff = e.clientX - startX;
    if (Math.abs(diff) > 40) goTo(diff > 0 ? index - 1 : index + 1);
  });

  // Keyboard support
  carousel.addEventListener('keydown', (e) => {
    if (e.key === 'ArrowLeft') goTo(index - 1);
    if (e.key === 'ArrowRight') goTo(index + 1);
  });

  goTo(0);
});

// Variant swatches active state
document.querySelectorAll('.pdp-swatch input').forEach((input) => {
  input.addEventListener('change', () => {
    const name = input.name;
    document.querySelectorAll(`.pdp-swatch input[name="${name}"]`).forEach((i) => {
      i.closest('.pdp-swatch').classList.toggle('is-active', i.checked);
    });
  });
});

// PDP tabs
document.querySelectorAll('[data-tabs]').forEach((tabs) => {
  const btns = tabs.querySelectorAll('.pdp-tab-btn');
  const panels = tabs.querySelectorAll('.pdp-tab-panel');
  btns.forEach((btn) => {
    btn.addEventListener('click', () => {
      const id = btn.dataset.tab;
      btns.forEach((b) => b.classList.toggle('is-active', b === btn));
      panels.forEach((p) => p.classList.toggle('is-active', p.dataset.panel === id));
    });
  });
});

// Happy customers carousel
document.querySelectorAll('[data-happy-carousel]').forEach((c) => {
  const track = c.querySelector('[data-happy-track]');
  const prev = c.querySelector('[data-happy-prev]');
  const next = c.querySelector('[data-happy-next]');
  const cards = track.querySelectorAll('.happy-card');
  if (!track || cards.length === 0) return;
  let index = 0;
  function step() {
    const w = cards[0].getBoundingClientRect().width + 24;
    const visible = Math.max(1, Math.floor(c.querySelector('[data-happy-viewport]').clientWidth / w));
    const max = Math.max(0, cards.length - visible);
    if (index > max) index = max;
    if (index < 0) index = 0;
    track.style.transform = `translateX(-${index * w}px)`;
  }
  prev && prev.addEventListener('click', () => { index--; step(); });
  next && next.addEventListener('click', () => { index++; step(); });
  window.addEventListener('resize', step);
  step();
});

// FAQ accordion: keep only one open
document.querySelectorAll('[data-faq]').forEach((root) => {
  const items = root.querySelectorAll('details');
  items.forEach((d) => d.addEventListener('toggle', () => {
    if (d.open) items.forEach((o) => { if (o !== d) o.open = false; });
  }));
});
